import { Attributes, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class PRPRate extends ModelBase {
    static typeName = "PRPRate";

    public prpRateId: number = 0;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    @Attributes.Display("PRP Date")
    public prpDate: Date | null = null;

    @Attributes.Float()
    @Attributes.Display("PRP Rate")
    public prpRateValue: number = 0;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
        rules.failWhen(c => c.prpRateValue < 0, "PRP Rate cannot be negative");
    }

    public toString(): string {
        if (this.isNew) {
            return "New prp rate";
        } else {
            return "PRP Rate";
        }
    }
}